import { useEffect, useState } from "react";
import { versionService } from "services/version/version-service";
import type { BackendVersionResponse } from "services/version/version-service";

export const useBackendVersion = () => {
  const [backendVersion, setBackendVersion] = useState<BackendVersionResponse>();

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchData() {
      try {
        const response = await versionService.getBackendVersion(abortController);

        if (response) {
          setBackendVersion(response);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);

  return backendVersion;
};
